<template>
  <!-- 专业岗位查询页面的关系图表 -->
  <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
  <!-- <ul :style="{height: identification.length-1 * 25 +'px',bottom:identification.length-1 * 25 + 10 +'px'}">
      <li v-for="(item,index) in identification" :key="index">
        <i :style="{background:colorList[index]}"></i>
        {{item.name}}：{{item.value}}
      </li>
    </ul> -->
</template>

// refId                 图表id
// datas                 图表数据源
// links                 数据之间的相关连接

<script>
export default {
  props: ['refId', 'datas', 'links'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
      // identification: [], //标识
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(this.refId, newValue, this.links);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas.length > 0) {
      this.setPieOption(this.refId, this.datas, this.links);
    }
  },
  methods: {
    setPieOption(refId, datas, links) {
      let data = JSON.stringify(datas);
      let link = JSON.stringify(links);
      data = JSON.parse(data);
      link = JSON.parse(link);

      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        tooltip: {
          trigger: 'item',
          confine: true, // 浮窗限制在图表内
          backgroundColor: 'rgba(64, 80, 118, 0.8)', // 通过设置rgba调节背景颜色与透明度
          borderColor: 'rgba(64, 80, 118, 0.8)',
          color: '#fff',
          textStyle: {
            color: '#fff',
          },
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          formatter: (name) => `${name.marker} ${name.name}`,
        },
        nimationEasingUpdate: 'quarticInOut',
        categories: [{
          itemStyle: {
            normal: {
              color: '#BB8FCE',
            },
          },
        }, {
          itemStyle: {
            normal: {
              color: '#0099FF',
            },
          },
        }, {
          itemStyle: {
            normal: {
              color: '#5DADE2',
            },
          },
        }],
        series: [{
          type: 'graph',
          layout: 'force', // 采用力引导布局
          force: {
            repulsion: 800, // 元素之间的间距
          },
          symbolSize:45,
          legendHoverLink: true, // 启用图例 hover 时的联动高亮。
          focusNodeAdjacency: true, // 在鼠标移到节点上的时候突出显示节点以及节点的边和邻接节点。
          animation: true, // 是否开启缩放和移动
          roam: true,
          label: {
            normal: {
              show: true,
              position: 'inside',
              formatter: '{b}',
              fontSize: 12,
              color: '#fff',
            },
          },
          lineStyle: { // 线条的样式
            normal: {
              opacity: 0.9,
              width: 1,
              curveness: 0.3, // 线条弯曲
            },
          },
          data,
          links: link,
        }],
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      this.pieEcharts.resize();
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped>
ul,
li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

ul {
  position: absolute;
  left: 0px;
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  padding: 5px 10px;
}
ul li {
  height: 15px;
  padding: 5px 5px;
  display: flex;
  align-items: center;
  color: #a5a4bf;
  font-size: 14px;
}

ul li i {
  width: 8px;
  height: 100%;
  border-radius: 3px;
  margin-right: 5px;
}
</style>
